import {z} from 'zod';
import {nameRegex} from './regex';

export const zodNameValidator = z
  .string()
  .trim()
  .regex(
    nameRegex,
    'Only letters, hyphens, spaces, and apostrophes are allowed',
  );
